import { motion } from "framer-motion";
import { Twitter, MessageCircle, Link2, Check } from "lucide-react";
import { useState } from "react";
import { SHARE_TEXT } from "@/lib/site";

// One-click share buttons: X (Twitter), WhatsApp, and copy-link.
export default function ShareButtons({ variant = "row", compact = false }) {
  const [copied, setCopied] = useState(false);
  const shareUrl =
    typeof window !== "undefined" ? window.location.origin : "";
  const text = encodeURIComponent(SHARE_TEXT);
  const url = encodeURIComponent(shareUrl);

  const links = [
    {
      key: "x",
      label: "Share on X",
      href: `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
      icon: Twitter,
      testid: "share-x-button",
    },
    {
      key: "wa",
      label: "Share on WhatsApp",
      href: `https://wa.me/?text=${text}%20${url}`,
      icon: MessageCircle,
      testid: "share-whatsapp-button",
    },
  ];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${SHARE_TEXT} ${shareUrl}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* noop */
    }
  };

  const btnBase = compact
    ? "px-4 py-2 text-[0.65rem]"
    : "px-5 py-3 text-xs";

  return (
    <div
      className={
        variant === "row"
          ? "flex flex-wrap items-center gap-3"
          : "grid grid-cols-1 gap-3 sm:grid-cols-3"
      }
      data-testid="share-buttons"
    >
      {links.map((l, i) => {
        const Icon = l.icon;
        return (
          <motion.a
            key={l.key}
            data-testid={l.testid}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -2 }}
            transition={{ duration: 0.25 }}
            className={`inline-flex items-center justify-center gap-2 border border-white/20 bg-transparent font-mono font-bold uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:border-rebellion hover:text-rebellion ${btnBase}`}
          >
            <Icon className="h-4 w-4" />
            {l.label}
          </motion.a>
        );
      })}
      <motion.button
        data-testid="share-copy-button"
        onClick={handleCopy}
        whileHover={{ y: -2 }}
        transition={{ duration: 0.25 }}
        className={`inline-flex items-center justify-center gap-2 border border-white/20 bg-transparent font-mono font-bold uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:border-rebellion hover:text-rebellion ${btnBase}`}
      >
        {copied ? <Check className="h-4 w-4 text-rebellion" /> : <Link2 className="h-4 w-4" />}
        {copied ? "Link Copied" : "Copy Link"}
      </motion.button>
    </div>
  );
}
